import ReqClient from './request.class'

// 添加广告组-批量
export async function addCampaignBatch(data) {
  const Req = new ReqClient({
    url: '/api/guangdiantong/campaign/batchAdd',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 获取游戏数据源
export async function getUserActionSetId(params) {
  const Req = new ReqClient({
    url: '/api/ptom/game/getUserActionSetId',
    params
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 获取所有落地页地址
export async function getBatchPages(params) {
  const Req = new ReqClient({
    url: '/api/guangdiantong/tool/getAllPages',
    params
    // url: '/api/guangdiantong/tool/getXiJingPages',
    // params: {
    //   ad_account_id: params.ad_account_id,
    //   app_id: params.promoted_object_id,
    //   app_type: params.promoted_object_type.substring(params.promoted_object_type.lastIndexOf('_') + 1)
    // }
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 新增头像地址
export async function addProfiles(params) {
  const Req = new ReqClient({
    url: '/api/guangdiantong/tool/profilesAdd',
    method: 'POST',
    params
  })
  try {
    return await Req.reqFormData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 获取所有头像地址
export async function getProfiles(params) {
  const Req = new ReqClient({
    url: '/api/guangdiantong/tool/profilesGet',
    params
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 新增品牌形象图片
export async function addBrands(params) {
  const Req = new ReqClient({
    url: '/api/guangdiantong/tool/brandAdd',
    method: 'POST',
    params
  })
  try {
    return await Req.reqFormData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 获取腾讯广告3.0 品牌形象列表
export async function getBrands(params) {
  const Req = new ReqClient({
    url: '/api/guangdiantong/tool/brandGet',
    method: 'GET',
    params
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 获取删除头像地址
export async function delProfiles(params) {
  const Req = new ReqClient({
    url: '/api/guangdiantong/tool/profilesDel',
    params
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 新建今日头条批量3.0任务
export async function addToutiaoBatchTask(data) {
  const Req = new ReqClient({
    url: '/api/ptom/ptomBatch/addGdtBatchTask',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 修改提交任务
export async function updatePlanTaskById(data) {
  const Req = new ReqClient({
    url: '/api/ptom/ptomBatch/updateGdtAdPlan',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 试玩页列表
export async function getWxGamePlayablePage(params) {
  const Req = new ReqClient({
    url: '/api/guangdiantong/tool/getWxGamePlayablePage',
    method: 'GET',
    params
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}
